module.exports = __webpack_public_path__ + "static/alaska-ccb586dfc91c012572d01f93840a7742.svg";